import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
      <div className="container-x px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 border border-white/20 flex items-center justify-center">
              <span className="font-display text-2xl text-[#FF3B30] leading-none">
                M
              </span>
            </div>
            <div>
              <div className="font-display text-2xl tracking-wider">
                MEÑO COACHING
              </div>
              <div className="text-[10px] tracking-[0.35em] text-[#FF3B30] uppercase">
                Pushing Limits
              </div>
            </div>
          </div>
          <p className="text-white/60 mt-6 max-w-md">
            Personal training, private lessons, soccer coaching and online
            programs led by Coach Manny. Based in Caldwell, Idaho — coaching
            clients everywhere.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mb-4">
            Services
          </div>
          <ul className="space-y-3 text-white/80">
            <li><a href="#services" className="hover:text-[#FF3B30]">Personal Training</a></li>
            <li><a href="#services" className="hover:text-[#FF3B30]">Private Lessons</a></li>
            <li><a href="#services" className="hover:text-[#FF3B30]">Soccer Coaching</a></li>
            <li><a href="#services" className="hover:text-[#FF3B30]">Online Classes</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-white/80">
            <li className="flex items-start gap-3">
              <Phone size={14} className="mt-1 text-[#FF3B30]" />
              <a href="tel:+12089019386" data-testid="footer-phone" className="hover:text-[#FF3B30]">
                (208) 901-9386
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={14} className="mt-1 text-[#FF3B30]" />
              <a href="mailto:mannyscoaching208@gmail.com" data-testid="footer-email" className="hover:text-[#FF3B30]">
                mannyscoaching208@gmail.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={14} className="mt-1 text-[#FF3B30]" />
              <span>16875 Live Oak Pl, Caldwell, ID 83607</span>
            </li>
          </ul>
          <div className="flex items-center gap-3 mt-6">
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="w-10 h-10 border border-white/15 flex items-center justify-center hover:border-[#FF3B30] hover:text-[#FF3B30] transition"
            >
              <Instagram size={16} />
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              data-testid="footer-facebook"
              className="w-10 h-10 border border-white/15 flex items-center justify-center hover:border-[#FF3B30] hover:text-[#FF3B30] transition"
            >
              <Facebook size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Meño Coaching · All rights reserved.</div>
          <div className="flex items-center gap-5">
            <Link
              to="/admin/login"
              data-testid="footer-coach-login"
              className="tracking-[0.2em] uppercase hover:text-[#FF3B30] transition-colors"
            >
              Coach Login
            </Link>
            <div className="tracking-[0.2em] uppercase">Pushing Limits — Every Session</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
